import { css } from '@emotion/core';
import { rgba, variables, media, tokens } from '@domain-group/fe-brary';
var colour = variables.colour,
  global = variables.global,
  font = variables.font;
var colors = tokens.colors;
export var container = {
  name: "79elbk",
  styles: "position:relative;"
};
export var tabsContainer = /*#__PURE__*/css("position:absolute;display:inline-block;top:20px;left:20px;z-index:", global.layerOverlay + 1, ";border-radius:2px;box-shadow:0 1px 10px 0 ", rgba(colour.black, 0.2), ";");
export var tab = _ref => {
  var isSelected = _ref.isSelected;
  return /*#__PURE__*/css("font-size:", font.smallFontSize, ";font-family:", font.bodyFontFamily, ";display:inline-block;padding:12px;border:0;outline:none;background:", colour.neutral50, ";color:", colour.neutral700, ";&:hover{cursor:pointer;}&:not(:last-child){border-right:1px ", colour.neutral300, " solid;}", isSelected && /*#__PURE__*/css("color:", colors.interactive.base.default, ";background-color:", colour.white, ";"));
};
export var streetView = _ref2 => {
  var mapOnly = _ref2.mapOnly;
  return /*#__PURE__*/css(media('>=tablet'), "{width:100%;height:", mapOnly ? '360px' : '480px', ";}", media('>=desktop'), "{width:", global.tabletMaxWidth, ";}.gm-iv-address{position:absolute;top:240px;min-width:150px;min-height:67px;}");
};
export var allhomesMap = _ref3 => {
  var mapOnly = _ref3.mapOnly;
  return /*#__PURE__*/css("width:100%;height:", mapOnly ? '300px' : '480px', ";", media('>=tablet'), "{height:", mapOnly ? '360px' : '480px', ";}", media('>=desktop'), "{max-width:", global.tabletMaxWidth, ";}");
};